//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        angle: {
            type: Number,
            default: 0
        },
        interactive: {
            type: Boolean,
            default: true
        },
        active: {
            type: Boolean,
            default: false
        }
    },

    data () {
        return {
            radius: 50,
            lineWidth: 4
        };
    }
};
